<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-card>
      <b-row>
        <b-col xl="6" md="6" sm="12">
          <span class="f-g">
            <h3>
              Promoção: {{ tituloPromocao }} - {{ dataInicialPromocao }} à
              {{ dataFinalPromocao }}
            </h3>
          </span>
        </b-col>
        <b-col xl="6" md="6" sm="12">
          <div>
            <b-button
              variant="success"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="atualizaPromocao"
            >
              <i class="fa fa-refresh fa-xl"></i>
              Atualizar itens
            </b-button>
            <b-button
              variant="danger"
              class="my-2 my-sm-0 w100 mr5"
              type="submit"
              @click="goBack"
            >
              <i class="fa fa-arrow-left"></i>
              Voltar
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col>
        <b-card style="text-align: center">
          <b-table
            bordered
            hover
            v-if="produtos.length > 0"
            striped
            responsive
            stickyColumn
            class="mb-0 pb-0"
            :items="produtos"
            :fields="fields_produtos"
            @row-clicked="rowHandle"
          >
            <template v-slot:cell(img)="data">
              <img
                v-if="data.item.img != -1"
                :src="data.item.img"
                alt="img"
                style="width: 50px; height: 50px"
                width="40"
                height="40"
                class="center-image"
                text-align="center"
              />
              <span v-else>Sem imagem</span>
            </template>
            <template v-slot:cell(valornormal)="data"
              >R$ {{ data.item.valornormal.toLocaleString("pt-BR") }}</template
            >
            <template v-slot:cell(valorpromocional)="data"
              >R$
              {{ data.item.valorpromocional.toLocaleString("pt-BR") }}</template
            >
            <template v-slot:cell(destaque)="data">
              <div class="fa-2x">
                <i v-if="data.item.destaque == 1" class="fa fa-star"></i>
                <i v-else class="fa fa-star-o"></i>
              </div>
            </template>
          </b-table>
          <center class="text-center f-g" v-else>
            <i class="fa fa-frown-o fa-custom-size"></i>
            <h4>Desculpe, não encontramos nenhum produto :(</h4>
          </center>
        </b-card>
      </b-col>
    </b-row>
    <b-modal ref="modalOpcoes" size="md" centered hide-footer>
      <div slot="modal-header">
        <small>{{ codBarrasSelecionado }}</small> -
        <strong>{{ descricaoSelecionado }}</strong>
      </div>
      <b-row>
        <b-col cols="6" @click="destacarProduto(idSelecionado)">
          <b-col cols="12" class="centerModal">
            <i
              v-if="produtoDestacado"
              class="fa fa-star fa-custom-size"
              aria-hidden="true"
            ></i>
            <i
              v-if="!produtoDestacado"
              class="fa fa-star-o fa-custom-size"
              aria-hidden="true"
            ></i>
            <span v-if="produtoDestacado">
              Remover
              <br />destaque
            </span>
            <span v-if="!produtoDestacado">
              Destacar
              <br />produto
            </span>
          </b-col>
        </b-col>
        <b-col cols="6" @click="editarImagem(urlImagemSelecionada)">
          <b-col cols="12" class="centerModal">
            <i class="fa fa-file-image-o fa-custom-size" aria-hidden="true"></i>
            <span v-if="!urlImagemSelecionada">
              Vincular
              <br />Imagem
            </span>
            <span v-if="urlImagemSelecionada">
              Editar
              <br />Imagem
            </span>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      ref="editarImagem"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div slot="modal-header">
        <small>{{ codBarrasSelecionado }}</small> -
        <strong>{{ descricaoSelecionado }}</strong>
      </div>
      <template slot="modal-footer">
        <b-button @click="closeModal(true)" variant="secondary"
          >Fechar</b-button
        >
        <b-button
          @click="newPhoto"
          variant="primary"
          :disabled="imagemSelecionado == null"
          >Upload</b-button
        >
      </template>
      <div v-if="mostravel">
        <picture-input
          ref="pictureInput"
          width="300"
          height="300"
          margin="16"
          accept="image/jpeg, image/png"
          size="10"
          button-class="changeBtn"
          remove-button-class="removeBtn"
          :removable="false"
          :custom-strings="{
            upload: '<h1>Seu dispositivo não aceita este tipo de envio.</h1>',
            drag: 'Arraste uma imagem <br> (ou clique aqui)',
            change: 'Mudar foto',
          }"
          @change="onChange"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import * as config from "@/config.json";
import Loading from "vue-loading-overlay";

import PictureInput from "vue-picture-input";

export default {
  components: {
    Loading,
    PictureInput,
  },
  data: () => {
    return {
      isLoading: false,
      produtos: [],
      fields_produtos: [
        { key: "img", label: "Imagem" },
        { key: "destaque", label: "Destaque" },
        { key: "codbarras", label: "Barras" },
        { key: "descricao", label: "Descrição" },
        { key: "valornormal", label: "Valor Normal" },
        { key: "valorpromocional", label: "Valor Promocional" },
      ],
      idPromocao: null,
      tituloPromocao: null,
      dataInicialPromocao: null,
      dataFinalPromocao: null,
      objPromocao: [],
      codBarrasSelecionado: null,
      descricaoSelecionado: null,
      urlImagemSelecionada: null,
      idSelecionado: null,
      produtoDestacado: false,
      isDestaque: null,
      imagemSelecionado: null,
      mostravel: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async destacarProduto() {
      if (this.urlImagemSelecionada == -1) {
        this.$refs.modalOpcoes.hide();
        await this.$alert(
          "Este produto não possui imagem, atribua uma antes de destacar.",
          "Aviso",
          "warning"
        );
        this.$refs.modalOpcoes.show();
      } else {
        this.isLoading = true;
        const url = `${config.default.servidor}/gerencial/promocao/item/destaque`;

        try {
          const response = await axios({
            url,
            method: "post",
            data: {
              id: this.idSelecionado,
              destaque: this.isDestaque,
            },
            headers: { authorization: config.default.authorizationBasic },
          });

          if (response.status == 200 || response.status == 201) {
            this.$refs.modalOpcoes.hide();
            await this.receberProdutos();
            this.isLoading = false;
            await this.$alert(
              `Destaque ${this.isDestaque ? "removido" : "aplicado"}!`,
              "Sucesso",
              "success"
            );
          }
        } catch (error) {
          console.log({ error });
        }
      }
    },

    async newPhoto() {
      if (this.imagemSelecionado == null) {
        this.closeModal(false);
        this.imagemSelecionado = null;

        await this.$alert("Necessário inserir uma imagem.", "Aviso", "warning");
        this.editarImagem();
      } else {
        this.isLoading = true;
        const imagem = this.imagemSelecionado;
        const codBarras = this.codBarrasSelecionado;

        this.closeModal(false);

        const url = `${config.default.servidor}/gerencial/promocao/item/imagem`;

        try {
          const response = await axios({
            url,
            method: "post",
            data: {
              empresaid: localStorage.getItem("enterprise_id").toString(),
              nomeDaImagem: codBarras,
              imagem: imagem,
            },
            headers: { authorization: config.default.authorizationBasic },
          });

          if (response.status == 200 || response.status == 201) {
            this.isLoading = false;
            await this.$alert("Imagem Atualizada!", "Sucesso", "success");
            this.items = {};
            await this.receberProdutos();
          }
        } catch (error) {
          this.isLoading = false;
          await this.$alert("Falha ao atualizar imagem!", "Erro", "error");
          console.log({ error });
        }
      }
    },

    editarImagem() {
      this.$refs.modalOpcoes.hide();
      this.$refs.editarImagem.show();
      setTimeout(() => {
        this.mostravel = true;
      }, 100);
    },

    onChange(image) {
      if (image) {
        this.imagemSelecionado = image;
      } else this.imagemSelecionado = null;
      console.info({ imagemSelecionado: this.imagemSelecionado });
    },

    closeModal(b) {
      this.imagemSelecionado = null;
      this.$refs.editarImagem.hide();
      this.mostravel = false;
      if (b) this.$refs.modalOpcoes.show();
    },

    rowHandle(record) {
      this.idSelecionado = record.id;
      this.codBarrasSelecionado = record.codbarras;
      this.descricaoSelecionado = record.descricao;
      this.urlImagemSelecionada = record.img;
      this.isDestaque = record = record.destaque;

      console.info({ codBarras: this.codBarrasSelecionado });

      if (this.isDestaque == 1) {
        this.produtoDestacado = true;
      } else {
        this.produtoDestacado = false;
      }

      this.$refs.modalOpcoes.show();
    },

    async gravaPromocao() {
      const url = `${config.default.servidor}/gerencial/promocao/itens`;

      try {
        const response = await axios({
          url,
          method: "post",
          data: {
            empresaid: localStorage.getItem("enterprise_id"),
            promocaoid: this.idPromocaoLocal,
            promocaowebid: this.idPromocao,
          },
          headers: { authorization: config.default.authorizationBasic },
        });

        if (!response.data.error) {
          this.isLoading = false;
          await this.receberProdutos();
          await this.$alert("Itens atualizados!", "Sucesso", "success");
        } else {
          this.isLoading = false;
          await this.$alert("Falha ao atualizar os itens!", "Erro", "error");
        }
      } catch (error) {
        console.log({ error });
      }
    },

    async atualizaPromocao() {
      this.$swal({
        title: "Promoção",
        text: "Ao atualizar os itens da promoção, você perderá as configurações de destaque. Deseja continuar?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((res) => {
        if (res.value) {
          this.gravaPromocao();
        }
      });
    },

    async receberProdutos() {
      const url = `${config.default.servidor}/gerencial/promocao/itens/web/${
        this.idPromocao
      }/${localStorage.getItem("enterprise_id")}`;

      try {
        const response = await axios({
          url,
          method: "get",
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.produtos = response.data.data;
        }
      } catch (error) {
        console.log({ error });
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    this.objPromocao = JSON.parse(localStorage.getItem("promocaoSelecionada"));
    this.idPromocao = this.objPromocao.id;
    this.idPromocaoLocal = this.objPromocao.id_local;
    this.tituloPromocao = this.objPromocao.titulo;
    this.dataInicialPromocao = this.objPromocao.data_inicial;
    this.dataFinalPromocao = this.objPromocao.data_final;
    await this.receberProdutos();
    this.isLoading = false;
  },
};
</script>